import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPersonalData = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={32}
    height={32}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M30 5v22H2V5h28Zm-2 2H4v18h24V7Zm-2 12v1.5h-7V19h7Zm0-4v1.5h-7V15h7Zm0-4v1.5h-7V11h7Z"
      />
      <g fill="currentColor" fillRule="nonzero">
        <path d="M11 11a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
        <path d="M11 16c3.184 0 4.926 1.676 4.998 4.799L16 21h-1.429c0-2.463-1.108-3.571-3.571-3.571-2.401 0-3.515 1.054-3.57 3.389L7.43 21H6c0-3.252 1.748-5 5-5Z" />
      </g>
    </g>
  </svg>
);
export default SvgIcPersonalData;
